import React, { useState } from 'react';
import { BookOpen, Plus, Search, HelpCircle, CheckCircle2, XCircle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Badge } from '../components/ui/badge';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';

const KnowledgeProofingPage = () => {
  const [searchTerm, setSearchTerm] = useState('');

  // Scrappy mock data for immediate UI testing
  const questionBanks = [
    { id: 1, title: 'Allergen Matrix Basics', questions: 12, status: 'Active', category: 'Food Safety' },
    { id: 2, title: 'Cellar Management', questions: 8, status: 'Active', category: 'Operations' },
    { id: 3, title: 'Fire Evacuation Proc.', questions: 5, status: 'Draft', category: 'Health & Safety' },
    { id: 4, title: 'Challenge 25 Rules', questions: 10, status: 'Active', category: 'Compliance' },
  ];

  return (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold font-heading text-[#FF6600] uppercase tracking-tight">
            Knowledge Proofing
          </h1>
          <p className="text-[#A1A1AA] mt-1">
            Create and manage spot-check questions for staff audits.
          </p>
        </div>
        <Button className="btn-rtb-primary bg-[#FF6600] hover:bg-[#CC5200] text-white">
          <Plus className="w-5 h-5 mr-2" />
          New Question Bank
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <Card className="bg-[#1E1E1E] border-[#3F3F46]">
          <CardContent className="p-6 flex items-center gap-4">
            <div className="p-3 bg-[#00E676]/20 rounded-lg">
              <CheckCircle2 className="w-6 h-6 text-[#00E676]" />
            </div>
            <div>
              <p className="text-2xl font-bold text-white">35</p>
              <p className="text-xs font-bold uppercase text-[#A1A1AA]">Active Questions</p>
            </div>
          </CardContent>
        </Card>
        <Card className="bg-[#1E1E1E] border-[#3F3F46]">
          <CardContent className="p-6 flex items-center gap-4">
            <div className="p-3 bg-[#FFB300]/20 rounded-lg">
              <HelpCircle className="w-6 h-6 text-[#FFB300]" />
            </div>
            <div>
              <p className="text-2xl font-bold text-white">84%</p>
              <p className="text-xs font-bold uppercase text-[#A1A1AA]">Avg. Pass Rate</p>
            </div>
          </CardContent>
        </Card>
        <Card className="bg-[#1E1E1E] border-[#3F3F46]">
          <CardContent className="p-6 flex items-center gap-4">
            <div className="p-3 bg-[#FF3B30]/20 rounded-lg">
              <XCircle className="w-6 h-6 text-[#FF3B30]" />
            </div>
            <div>
              <p className="text-2xl font-bold text-white">12</p>
              <p className="text-xs font-bold uppercase text-[#A1A1AA]">Failed Spot-Checks (7d)</p>
            </div>
          </CardContent>
        </Card>
      </div>

      <Card className="bg-[#1E1E1E] border-[#3F3F46]">
        <CardHeader>
          <div className="flex items-center justify-between">
            <CardTitle className="text-white flex items-center gap-2">
              <BookOpen className="w-5 h-5 text-[#FF6600]" />
              Question Banks
            </CardTitle>
            <div className="relative w-64">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#A1A1AA]" />
              <Input 
                placeholder="Search banks..." 
                className="pl-9 bg-[#0A0A0A] border-[#3F3F46] text-white focus-visible:ring-[#FF6600]"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            {questionBanks
              .filter(bank => bank.title.toLowerCase().includes(searchTerm.toLowerCase()))
              .map((bank) => (
              <div key={bank.id} className="flex items-center justify-between p-4 bg-[#27272A] border border-[#3F3F46] rounded-lg hover:border-[#FF6600] transition-colors cursor-pointer">
                <div>
                  <h3 className="text-white font-medium">{bank.title}</h3>
                  <div className="flex gap-3 mt-1 text-sm text-[#A1A1AA]">
                    <span>{bank.questions} Questions</span>
                    <span>•</span>
                    <span>{bank.category}</span>
                  </div>
                </div>
                <Badge className={bank.status === 'Active' ? 'bg-[#00E676]/20 text-[#00E676]' : 'bg-[#FFB300]/20 text-[#FFB300]'}>
                  {bank.status}
                </Badge>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default KnowledgeProofingPage;